<div class="user-email">
  <app-autocomplete-selector
    *ngIf="!isAddingNew"
    [label]="'popup.share_study_by_email.user' | translate"
    [filter]="onFilterUsers"
    [resetAfterSelected]="true"
    [isRequired]="true"
    [extraValidators]="getEmailValidators()"
    (selectItemChanged)="onSelectedUserChanged($event)"
    (valueChanged)="onValueChanged($event)"
    (validityChanged)="onValidityChanged($event)">
  </app-autocomplete-selector>

  <button
    mat-button
    class="add-button"
    *ngIf="!isAddingNew"
    (click)="addNew()"
    [disabled]="!isValidEmail || isUserFound || email == null">
    {{ 'popup.share_study_by_email.add_button' | translate }}
  </button>
</div>

<mat-card *ngIf="isAddingNew">
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study_by_email.add.title' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div>
      <div class="email">{{ email }}</div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'popup.share_study_by_email.profile' | translate }}</mat-label>
        <mat-select [formControl]="profilFormControl" required>
          <mat-option *ngFor="let profile of profiles" [value]="profile">{{ ('PROFILE.' + profile).toLowerCase() | translate }}</mat-option>
        </mat-select>
        <mat-error *ngIf="profilFormControl.invalid">{{ 'popup.share_study_by_email.err_profile_required' | translate }}</mat-error>
      </mat-form-field>
      <div *ngIf="profilFormControl.value">
        <mat-form-field appearance="outline" *ngIf="profilFormControl.value == 'INVITED_CLINIC'; else user_template">
          <mat-label>{{ 'popup.share_study_by_email.clinic_type' | translate }}</mat-label>
          <mat-select [formControl]="clinicTypeFormControl" required>
            <mat-option *ngFor="let clinicType of clinicTypes$ | async" [value]="clinicType">{{ clinicType.label }}</mat-option>
          </mat-select>
          <mat-error *ngIf="clinicTypeFormControl.invalid">{{ 'popup.share_study_by_email.err_clinic_type_required' | translate }}</mat-error>
        </mat-form-field>

        <ng-template #user_template>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'popup.share_study_by_email.first_name' | translate }}</mat-label>
            <input matInput [required]="profilFormControl.value !== 'CLIENT'" [formControl]="firstNameFormControl">
            <mat-error *ngIf="firstNameFormControl.hasError('required')">{{ 'popup.share_study_by_email.err_first_name_required' | translate }}</mat-error>
          </mat-form-field>
        </ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ (profilFormControl.value !== 'INVITED_CLINIC' ? 'popup.share_study_by_email.last_name' : 'popup.share_study_by_email.clinic_name') | translate }}</mat-label>
          <input matInput [required]="profilFormControl.value !== 'CLIENT'" [formControl]="lastNameFormControl">
          <mat-error *ngIf="lastNameFormControl.hasError('required')">
            {{ (profilFormControl.value !== 'INVITED_CLINIC' ? 'popup.share_study_by_email.err_last_name_required' : 'popup.share_study_by_email.err_clinic_name_required') | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="actions">
        <button mat-button (click)="ok()" [disabled]="isInvalidNewUser()">{{ 'popup.share_study_by_email.add.ok_button' | translate }}</button>
        <button mat-button (click)="cancel()">{{ 'popup.share_study_by_email.add.cancel_button' | translate }}</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="targets" *ngIf="selectedUsers.length > 0 || newUsers.length > 0">
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study_by_email.targets' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let user of selectedUsers">
        {{ user.label }}
        <button class="delete-button" mat-mini-fab color="accent" (click)="deleteUserById(user.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
    <mat-list>
      <mat-list-item *ngFor="let user of newUsers">
        {{ user.email }} ({{ user.firstName }} {{ user.lastName }})
        <button class="delete-button" mat-mini-fab color="accent" (click)="deleteUserByEmail(user.email)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
